module.exports = __webpack_public_path__ + "static/media/rc.6d62cd5a.png";